export const PROFILE_SISTEMAS = 1;
export const PROFILE_OGA = 2;
export const PROFILE_FISCAL = 3;
export const PROFILE_JUEZ = 4;
export const PROFILE_JUEZ_IMPUGNACION = 7;
export const PROFILE_DEFENSA = 5;
export const PROFILE_ABOGADO = 6;

export default [
    {
        id: PROFILE_SISTEMAS,
        descripcion: 'SISTEMAS'
    },
    {
        id: PROFILE_OGA,
        descripcion: 'OGA'
    },
    {
        id: PROFILE_FISCAL,
        descripcion: 'MINISTERIO FISCAL'
    },
    {
        id: PROFILE_JUEZ,
        descripcion: 'JUEZ'
    },
    {
        id: PROFILE_JUEZ_IMPUGNACION,
        descripcion: 'JUEZ IMPUGNACIÓN'
    },
    {
        id: PROFILE_DEFENSA,
        descripcion: 'MINISTERIO DE LA DEFENSA'
    },
    {
        id: PROFILE_ABOGADO,
        descripcion: 'ABOGADO'
    }
]